import service from '@/utils/request'
import store, { baseAPI, baseUrl } from '../store'

const apiConst = {
  // 勋章相关接口
  medal_list: baseAPI + baseUrl + 'config/medal/list',
  insert_medal: baseAPI + baseUrl + 'config/medal/insert',
  update_medal: baseAPI + baseUrl + 'config/medal/update'
}

// 勋章配置列表
export const getMedalList = async (page, data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.medal_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      page: page
    },
    data
  })
  return res
}

// 插入勋章
export const insertMedal = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.insert_medal,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}

// 更新勋章
export const updateMedal = async (type, data) => {
  let updateData = null
  if (type === 1) {
    updateData = { valid: 0, id: data }
  } else if (type === 0) {
    updateData = { valid: 1, id: data  }
  } else {
    updateData = data
  }
  const { data: res } = await service({
    method: 'post',
    url: apiConst.update_medal,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data: updateData
  })
  return res
}